module.exports = __webpack_public_path__ + "img/conny-stage7-hungry.bd9f63c3.png";